









































import { Component, Vue } from 'vue-property-decorator';
import ShowDevDialog from '@/components/dialogs/ShowDevDialog.vue';

@Component({
    components: {
        ShowDevDialog
    }
})
export default class About extends Vue {
    private clickCount = 0;

    private click(on) {
        this.clickCount += 1;
        if (this.clickCount > 5) {
            on();
        }
    }
}
